
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, X, Gift } from 'lucide-react';

interface PromoBannerProps {
  onClose: () => void;
}

const PromoBanner: React.FC<PromoBannerProps> = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 8000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 500);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -100, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -100, scale: 0.9 }}
          className="fixed top-6 left-4 right-4 z-[200] flex justify-center pointer-events-none"
        >
          <div className="glass-card rounded-[2.5rem] p-1 bg-gradient-to-r from-yellow-400/40 via-amber-500/40 to-yellow-400/40 border border-yellow-400/50 shadow-[0_0_40px_rgba(251,191,36,0.3)] backdrop-blur-2xl pointer-events-auto max-w-md w-full overflow-hidden">
            <div className="relative bg-indigo-950/90 rounded-[2.3rem] px-6 py-4 flex items-center gap-4">
              <div className="relative">
                <div className="absolute inset-0 bg-yellow-400 blur-xl opacity-20 animate-pulse"></div>
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-yellow-300 to-amber-500 flex items-center justify-center shadow-lg transform -rotate-6">
                  <Gift className="w-6 h-6 text-indigo-950" />
                </div>
              </div>
              
              <div className="flex-1">
                <h4 className="text-yellow-400 font-black uppercase tracking-widest text-[10px] mb-1">Dhuratë Mirëseardhjeje</h4>
                <p className="text-white text-sm font-medium leading-tight">
                  Urime! Sapo fitove <span className="text-yellow-400 font-bold">2 xhevaire</span> magjike për të krijuar përralla!
                </p>
              </div>

              <button 
                onClick={handleClose}
                className="p-2 hover:bg-white/10 rounded-full transition-colors group"
              >
                <X className="w-4 h-4 text-white/40 group-hover:text-white" />
              </button>

              {/* Sparkles animation */}
              <div className="absolute top-0 right-12 pointer-events-none">
                <Sparkles className="w-4 h-4 text-yellow-400 animate-bounce opacity-50" />
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PromoBanner;
